$(function() {

	Forms.init();
	Dashboard.init();
	Payment.init();

	$('[data-toggle="tooltip"]').tooltip();
});